S.listWebinar = {
    config: {
        filter: 0,
        action: 'list',
    },

    elements: {
        $filterHead: null,
        $filterItem: null,
        $listContainer: null,
        $loadButton: null,
        $showAllFilter: null,
        $button: null,
        $teaser: null,
        $filter: null,
        $currentFilter: null,
        $activeType: null,
    },

    originFilter: [],
    currentFilter: [],
    page: null,
    renewList: true,
    reset: 0,

    init()
    {
        this.elements.$filterHead.on('click', (element) =>
        {
            this.elements.$filterHead.not(element.currentTarget).removeClass('is-open');
            this.elements.$filterHead.not(element.currentTarget).children().removeClass('is-open');

            $(element.currentTarget).toggleClass('is-open');
            $(element.currentTarget).children().toggleClass('is-open');
        });

        if (!this.page)
        {
            this.page = 2;
        }
        this.originFilter['type'] = this.elements.$listContainer.data('type');


        if (this.config.action === 'filter')
        {
            this.elements.$loadButton.on('click', () =>
            {
                this.renewList = false;
                this.loadArticles();
                this.page++;
            });
        }

        this.initFilters();
    },

    loadArticles()
    {
        const container = this.elements.$listContainer;
        const loadButton = this.elements.$loadButton;
        const ajaxUrl = container.attr('data-ajaxUrl');
        const storagePid = container.attr('data-storagepid');
        const data = {};

        data['tx_project_webinararticlefilter[page]'] = this.page;
        data['tx_project_webinararticlefilter[type]'] = this.checkFilter().slice(0, -1);
        data['tx_project_webinararticlefilter[more]'] = true;
        data['tx_project_webinararticlefilter[storagePid]'] = storagePid;
        data['tx_project_webinararticlefilter[reset]'] = this.reset;

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: data,
            cache: false,
            success: (data) =>
            {
                // HTML Output
                if (this.renewList)
                {
                    container.html($(data).find('.m-main').html());
                    this.page++;
                }
                else
                {
                    container.append($(data).find('.m-main').html());
                }
                if ($(data).find('.m-load-button').hasClass('is-hidden'))
                {
                    loadButton.hide();
                }
                else
                {
                    loadButton.show();
                }
            },
            error: (e) =>
            {
                // eslint-disable-next-line no-console
                console.log(e, 'error');
            },
        });
    },

    initFilters()
    {
        this.elements.$filterItem.on('click', (element) =>
        {
            this.page = 1;
            this.renewList = true;
            this.currentFilter.push($(element.currentTarget).attr('data-uid'));
            this.reset = 0;

            this.displayFilter();
        });
    },

    resetFilter()
    {
        this.currentFilter = [];
        this.page = 1;
        this.reset = 1;
        this.elements.$listContainer.data('type', this.originFilter['type']);


        this.loadArticles();
    },

    displayFilter()
    {
        const currentFilter = Object.assign({}, this.currentFilter);

        this.elements.$currentFilter.html('');
        $.each(currentFilter, (key, value) =>
        {
            this.elements.$currentFilter.append('<p class="m-active-type js-active-type" data-name="type" data-uid="' + value + '" >' + $('.m-item.js-filter-item[data-uid=' + value + ']').text() + '</p>');
        });


        this.filterEnabled();
    },

    filterEnabled()
    {
        this.currentFilter = [];
        this.elements.$currentFilter.children().before().on('click', (e) =>
        {
            $(e.currentTarget).remove();
            this.page = 1;
            this.renewList = true;
            this.filterEnabled();
        });

        this.elements.$currentFilter.children().each((index) =>
        {
            this.currentFilter.push(this.elements.$currentFilter.children().eq(index).attr('data-uid'));
        });

        if (Object.keys(this.currentFilter).length === 0)
        {
            this.resetFilter();
        }
        else
        {
            this.loadArticles();
        }
    },

    getRightValue(item)
    {
        if (item)
        {
            return item;
        }

        return '0';
    },

    checkFilter()
    {
        this.checkDuplicated();
        if (Object.keys(this.currentFilter).length === 0)
        {
            return this.originFilter['type'] + ',';
        }
        let value = '';

        this.currentFilter.forEach(function (item)
        {
            value += item + ',';
        });

        return value;
    },

    checkDuplicated()
    {
        var testarray = [];

        this.elements.$currentFilter.children().each((index) =>
        {
            if (testarray.indexOf(this.elements.$currentFilter.children().eq(index).data('uid')) === -1)
            {
                testarray.push(this.elements.$currentFilter.children().eq(index).data('uid'));
            }
            else
            {
                this.elements.$currentFilter.children().eq(index).remove();
            }
        });
    },

    checkColor()
    {
        let filer = 0;

        this.elements.$filter.children().each(function ()
        {
            if ($(this).children().length)
            {
                $(this).removeClass('is-active is-inactive');
                $(this).has('.is-active').addClass('is-active');
                $(this).not('.is-active').addClass('is-inactive');
            }

            if ($(this).is('.is-active'))
            {
                filer = 1;
            }
        });

        if (!filer)
        {
            this.elements.$filter.children().each(function ()
            {
                $(this).removeClass('is-inactive');
            });
        }

        const event = ($('.mod-teaser-standard-triple .m-mask.is-active').first().attr('data-name'));

        if ((event === 'Events') || (event === 'Veranstaltungen'))
        {
            this.elements.$eventFilter.show();
            this.elements.$listContainer.hide();
        }
        else
        {
            this.elements.$eventFilter.hide();
            this.elements.$listContainer.show();
        }
    },
};
